import { render, staticRenderFns } from "./_direct_orders.subtab.vue?vue&type=template&id=50cdd318&scoped=true&"
import script from "./_direct_orders.subtab.vue?vue&type=script&lang=js&"
export * from "./_direct_orders.subtab.vue?vue&type=script&lang=js&"
import style0 from "./_direct_orders.subtab.vue?vue&type=style&index=0&id=50cdd318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cdd318",
  null
  
)

export default component.exports